import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { beginJoin } from 'actions/creators/Auth'

class SignUp extends React.Component {
  componentDidMount = () => {
    this.props.beginJoin()
    this.props.router.push('/')
  }

  render() {
    return <h1>SignUp</h1>
  }
}

export default withRouter(connect((s) => s, { beginJoin })(SignUp))



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/SignUp.jsx